
import { Link } from "react-router-dom";
import { useState } from "react";
import "./header.css";

function Header({ userId, user, onLogin, onLogout }) {
    const [menuOpen, setMenuOpen] = useState(false);

    const isLoggedIn = !!userId; // ✅ FIXED

    const username = user?.email
        ? user.email.split("@")[0]
        : null;

    return (
        <header className="header">
            <div className="header-inner">

                {/* LOGO */}
                {/* LOGO */}
                <Link
                    to={isLoggedIn && username ? `/community/${username}` : "/"}
                    className="logo"
                >
                    Portfolio
                </Link>

                <div
                    className={`hamburger ${menuOpen ? "active" : ""}`}
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <nav className={`nav ${menuOpen ? "open" : ""}`}>
                    <ul className="nav-links">

                        {/* 🔓 NOT LOGGED IN */}
                        {!isLoggedIn && (
                            <>
                                {/* COMMUNITY LINK */}
                                <li>
                                    <Link to="/community" onClick={() => setMenuOpen(false)}>
                                        Community
                                    </Link>
                                </li>

                                <li>
                                    <button className="btn login" onClick={onLogin}>
                                        Login
                                    </button>
                                </li>
                            </>
                        )}

                        {/* 🔐 LOGGED IN */}
                        {isLoggedIn && username && (
                            <>
                                <li>
                                    <Link to={`/${username}/entry`} onClick={() => setMenuOpen(false)}>
                                        Entry
                                    </Link>
                                </li>

                                <li>
                                    <Link to={`/${username}/partnership`} onClick={() => setMenuOpen(false)}>
                                        Partnership
                                    </Link>
                                </li>

                                <li>
                                    <Link to={`/community/`} onClick={() => setMenuOpen(false)}>
                                        Community
                                    </Link>
                                </li>

                                <li>
                                    <button className="btn logout" onClick={onLogout}>
                                        Logout
                                    </button>
                                </li>
                            </>
                        )}

                    </ul>
                </nav>

            </div>
        </header>
    );
}

export default Header;